var render = function render(){var _vm=this,_c=_vm._self._c;return _c('datetime',{attrs:{"auto":"true"},model:{value:(_vm.fieldValue),callback:function ($$v) {_vm.fieldValue=$$v},expression:"fieldValue"}},[_c('template',{slot:"button-cancel"},[_vm._v(" Cancel ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }